import { render, staticRenderFns } from "./TeacherLeave.vue?vue&type=template&id=d5d670d6&scoped=true&"
import script from "./TeacherLeave.vue?vue&type=script&lang=js&"
export * from "./TeacherLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d670d6",
  null
  
)

export default component.exports